import React from "react";
import { ItemIssueList } from "../../components/ItemIssue/ItemIssueList";

export const InvItemIssuesPage = () => {
  return <ItemIssueList />;
};
